import React, { Component } from "react";
import styled from "styled-components";
import { rgba } from "polished";
import { getVars } from "../global/utils";
import MainLayout from "../layouts/MainLayout";
import PageHeader from "../components/shared/PageHeader";
import Heading from "../components/text/Heading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFolder } from "@fortawesome/free-solid-svg-icons";
import Pusher from 'pusher-js';


const ChatContent = styled.div`
  .projects__layout {
    display: flex;
    flex-direction: column;
  }
  .projects__header {
    box-shadow: 0 8px 16px ${rgba(getVars("black", "_50"), 0.1)};
    position: relative;
    z-index: 1;
    h1{
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .projects__map {
    flex-grow: 1;
  }
`;

class Chat extends Component {
    constructor() {
        console.log("realtime constructor")
        super();

        this.state = {
            latitude : '',
            longitude : '',
        };
    }

    componentDidMount() {
        console.log('didmount');
        console.log('-----------------');
        console.log(process.env.REACT_APP_PUSHER_APP_KEY);
        console.log('-----------------');

      // Enable pusher logging - don't include this in production
        // Pusher.logToConsole = true;
        const pusher = new Pusher(process.env.REACT_APP_PUSHER_APP_KEY, {
            cluster: process.env.REACT_APP_PUSHER_APP_CLUSTER,
            forceTLS: true
        });



        let channel = pusher.subscribe('gps-channel');
        channel.bind('room_'+process.env.REACT_APP_CLW_ROOM_UT_NAME_32482, function(data) {
            console.log(JSON.stringify(data));
            console.log(new Date().toLocaleTimeString());
        });

    };

    render() {

        return (
          <ChatContent>
            <MainLayout className="projects__layout">
              <PageHeader className="projects__header">
                <Heading level="heading1">
                  <h1>
                    <FontAwesomeIcon icon={faFolder} />
                    CHAT PUSHER
                  </h1>
                </Heading>
              </PageHeader>
              <span>{this.state.latitude}, {this.state.longitude}</span>
            </MainLayout>
          </ChatContent>
        );
    }
}
export default Chat;



// WEBPACK FOOTER //
// ./src/pages/tmp_ChatPusher.js